import "./Header.scss";
import logo from "../../assets/images/logo3.png";
import { NavLink, useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import Search from "../Search/Search";
import { loginCheck, defaultImg } from "../../utils/helper";
import Modal from "../Modal/Modal";
import Burger from "../Burger/Burger";

const Header = ({
  userData,
  analysis,
  timeInterval,
  setTimeInterval,
  postsAnalyzed,
  setPostsAnalyzed,
  setSearchTerm,
  logoutHandler,
  subreddits,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [openBurger, setOpenBurger] = useState(false);

  const history = useHistory();

  useEffect(() => {
    document.addEventListener("scroll", () => {
      window.scrollY > 20 ? setScrolled(true) : setScrolled(false);
    });
  }, [scrolled]);

  return (
    <header
      className={`header ${scrolled || openBurger ? "header--scrolled" : ""} ${
        history.location.pathname.length > 1 ? "header--white-bg" : ""
      }`}
    >
      <nav className="navbar">
        <NavLink to="/">
          <img
            src={logo}
            className={`navbar__logo ${
              scrolled || history.location.pathname.length > 1 || openBurger
                ? "navbar__logo--scrolled"
                : ""
            }`}
            alt="Eureka logo"
          />
        </NavLink>
        {history.location.pathname.length > 1 && (
          <Search
            analysis={analysis}
            timeInterval={timeInterval}
            setTimeInterval={setTimeInterval}
            postsAnalyzed={postsAnalyzed}
            setPostsAnalyzed={setPostsAnalyzed}
            setSearchTerm={setSearchTerm}
            subreddits={subreddits}
            className="searchbar--small"
          />
        )}
        <Burger
          loginCheck={loginCheck}
          userData={userData}
          scrolled={scrolled}
          setOpenModal={setOpenModal}
          openBurger={openBurger}
          setOpenBurger={setOpenBurger}
        />
        <ul className="navbar__list">
          <li
            className={`navbar__list-item ${
              scrolled ? "navbar__list-item--scrolled" : ""
            } ${
              history.location.pathname.length > 1
                ? "navbar__list-item--purple"
                : ""
            }`}
          >
            <NavLink to="/"> Home</NavLink>
          </li>
          <li
            className={`navbar__list-item ${
              scrolled ? "navbar__list-item--scrolled" : ""
            } ${
              history.location.pathname.length > 1
                ? "navbar__list-item--purple"
                : ""
            }`}
            onClick={() => {
              // check if logged in, if not redirect to log in page
              loginCheck(false, userData, history);
            }}
          >
            <div
              className={`navbar__beta ${
                scrolled || history.location.pathname.length > 1
                  ? "navbar__beta--scrolled"
                  : ""
              }`}
            >
              New AI Features
            </div>
            Schedule a Post
          </li>
          {userData.username !== null && (
            <li
              className={`navbar__list-item ${
                scrolled ? "navbar__list-item--scrolled" : ""
              } ${
                history.location.pathname.length > 1
                  ? "navbar__list-item--purple"
                  : ""
              }`}
              onClick={() => {
                setOpenModal(true);
              }}
            >
              <article className="navbar-login">
                <img
                  src={userData.icon_img}
                  onError={(e) => (e.currentTarget.src = defaultImg)}
                  alt="reddit user icon"
                  className="navbar-login__img"
                />{" "}
                <span className="navbar-login__username">
                  {userData.username}
                </span>
              </article>
            </li>
          )}
        </ul>
        <Modal
          openModal={openModal}
          setOpenModal={setOpenModal}
          onClickHandler={logoutHandler}
        />
 
      </nav>
      {history.location.pathname.length > 1 && (
          <Search
            analysis={analysis}
            timeInterval={timeInterval}
            setTimeInterval={setTimeInterval}
            postsAnalyzed={postsAnalyzed}
            setPostsAnalyzed={setPostsAnalyzed}
            setSearchTerm={setSearchTerm}
            subreddits={subreddits}
            className="searchbar--mobile"

          />
        )}
    </header>
  );
};

export default Header;
